<div class="card">
  <div class="card-header d-flex justify-content-between align-items-center">
    <div class="col">
      <h3 class="card-title mb-0">{{config?.cardTitle}}</h3>
    </div>
    @if (config?.addNewItemButton) {
      <div class="col d-flex justify-content-end">
        <custom-button [config]="config?.addNewItemButton" />
      </div>
    }
  </div>
  <div class="card-body">
    <ng-content />
    <data-table
      [config]="config?.dataTable"
      (onPageChange)="onPageChange($event)"
      (onFilterChange)="onFilterChange($event)"
      (onPageSizeChange)="onPageSizeChange($event)"
      (onSortChange)="onSortChange($event)"
      (onExportExcel)="exportExcel()"
      [service]="service"
      [idKey]="idKey"
      [subSectionSettings]="subSectionSettings"
      [currentPage]="currentPage"
      [pageSize]="pageSize"
      [showExportButton]="!!config?.exportExcelService"
      [isExporting]="isExporting"
      />
  </div>
  @if (config?.addNewItemButton) {
    <div class="card-footer ">
      <div class="col-12 d-flex justify-content-center my-2">
        <custom-button [config]="config?.addNewItemButton" />
      </div>
    </div>
  }
</div>